import { Environment, Network, RecordSource, Store } from '@boltline/relay-runtime';
import User from 'helper/currentUser';

import request from 'helper/NetworkLayer';

import { awsEndpoint } from './helper/url';
import cookie from './helper/cookie';
import validateJWT from './helper/validateJWT';
import refetchTokens from './helper/refetchTokens';

const user = new User();

export default function setupRelayModernEnvironment() {
  const store = new Store(new RecordSource());

  const fetchQuery = async (operation, variables) => {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    if (user.isMasqueraded()) {
      headers.masquerade = JSON.stringify({ _id: user.id() });
      headers.user = JSON.stringify({ _id: user.id() });
    }

    let lyearnToken = cookie.get('lyearn_token');
    const isValid = validateJWT(lyearnToken);
    if (!isValid) {
      await refetchTokens();
    }
    lyearnToken = cookie.get('lyearn_token');
    headers.lyearn_token = lyearnToken;

    if (!headers.lyearn_token) {
      window.bugsnagClient
        && window.bugsnagClient.notify(new Error('lyearn_token_not_found'), {
          metaData: {
            type: 'custom_error_track',
            message: 'lyearn_token_not_found',
            operation,
            headers,
            cookies: document.cookie,
            userId: user.id(),
            time: new Date().toISOString()
          }
        });
    }

    const graphEndpoint = `${awsEndpoint}/graphql?apiEndpoint=oldbackendapi`;

    const response = await request(graphEndpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        query: operation.text,
        variables
      })
    });
    const responseJSON = await response.json();
    return responseJSON;
  };

  if (!global.relayModernEnvironment) {
    const network = Network.create(fetchQuery);
    const environment = new Environment({ network, store });

    global.relayModernEnvironment = environment;
  }
}
